module.exports = __webpack_public_path__ + "img/sweet-home-3d@2x.cd5a6295.png";